import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetVIQDashboard_viqDashboard as VIQDashboard,
    GetVIQDashboard as GetVIQDashboardQuery,
    GetVIQDashboardVariables as GetVIQDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_VIQ_DASHBOARD from '../queries/get-viq-dashboard.graphql';

export const useGetVIQDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    viqDashboard: VIQDashboard;
    originId: string;
} => {
    const {loading, data, error} = useQuery<GetVIQDashboardQuery, GetVIQDashboardQueryVariables>(
        GET_VIQ_DASHBOARD,
        {
            variables: {input},
            notifyOnNetworkStatusChange: true,
        }
    );

    const {viqDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        viqDashboard,
        originId: viqDashboard && viqDashboard.originId,
    };
};
